import { List } from 'immutable';
import Big from 'big.js';

import { isUploadFilesSupported } from '../product/checkAttribute';
import { toLowerCase } from '../string';
import { getSize } from '../iterable/getSize';
import { get } from '../iterable/get';

import { ERRORS, MAX_FILE_NAME_LENGTH, MAX_FILE_SIZE } from '../../constants/validations';
import { OPERATIONS, VALUE } from '../../constants/product';
import { ATTRIBUTE } from '../../constants/attributes';
import { EMPTY } from '../../constants';
import { ETSY } from '../../constants/channels';
import { FORM } from '../../constants/forms';

function getFileSizeError({ channel, value }) {
  return (
    channel in MAX_FILE_SIZE &&
    new Big(MAX_FILE_SIZE[channel]).lt(value) &&
    ERRORS.FILES.TOO_BIG[channel]
  );
}

export function validateNames({ channel, file, files = [], fileNames = EMPTY.LIST, operationType, startIndex }) {
  function reduceNames(result, fileName) {
    return result || (
      typeof fileName === 'string' &&
      toLowerCase(fileName) === toLowerCase(get('name')(file)) &&
      `File with name "${get('name')(file)}" already exist`
    );
  }

  switch (operationType) {
    case OPERATIONS[channel].FILES.ADD: {
      return fileNames
        .concat(List(files.map(get('name'))))
        .reduce(reduceNames, false);
    }

    case OPERATIONS[channel].FILES.REPLACE: {
      return fileNames
        .splice(startIndex, getSize(files) + 1, ...files.map(get('name')))
        .reduce(reduceNames, false);
    }

    default: {
      return false;
    }
  }
}

function getFileNameError({ channel, value }) {
  const name = (value.match(/.*(?=\.[a-zA-Z0-9]*$)/) || [''])[0];

  if (channel in MAX_FILE_NAME_LENGTH && name.length > MAX_FILE_NAME_LENGTH[channel]) {
    return ERRORS.FILES.NAME_LENGTH_EXCEEDED[channel];
  }

  switch (channel) {
    case ETSY: {
      return (
        /[^\p{L}\p{Nd}\-_\.]/u.test(name) &&
        ERRORS.FILES.NAME_FORBIDDEN_CHARACTERS[channel]
      );
    }

    default: {
      return false;
    }
  }
}

export function getFileError({ channel, file }) {
  const { name, size } = file;

  return (
    getFileSizeError({ channel, value: size }) ||
    getFileNameError({ channel, value: name })
  );
}

export function validateFiles({ channel, product }) {
  let errors = EMPTY.MAP;

  switch (channel) {
    case ETSY: {
      if (!product.getIn([FORM.DETAILS, ATTRIBUTE.DIGITAL, VALUE])) break;

      if (isUploadFilesSupported({ product })) {
        if (!getSize(product.getIn([FORM.FILES, VALUE]))) {
          errors = errors.set(FORM.FILES, ERRORS.FILES.REQUIRED);
        }
      } else if (getSize(product.getIn([FORM.FILES, VALUE]))) {
        errors = errors.set(FORM.FILES, ERRORS.DETAILS.DIGITAL_MADE_TO_ORDER);
      }

      break;
    }

    default: {
      break;
    }
  }

  return errors;
}
